if (!customElements.get('printspar-language-switcher')) {
  customElements.define(
    'printspar-language-switcher',
    class PrintsparLanguageSwitcher extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.localeInput = this.form?.querySelector('input[name="locale_code"]');
        this.onLocaleClick = this.onLocaleClick.bind(this);
        this.addEventListener('click', this.onLocaleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onLocaleClick);
      }

      onLocaleClick(event) {
        const option = event.target.closest('[data-locale-code]');
        if (!option || !this.contains(option) || !this.form || !this.localeInput) return;

        const localeCode = option.dataset.localeCode;
        if (!localeCode || localeCode === this.localeInput.value) {
          this.querySelector('details')?.removeAttribute('open');
          return;
        }

        this.localeInput.value = localeCode;
        this.form.submit();
      }
    }
  );
}
